import { cn } from '@/lib/utils'
import { SUBSCRIPTION_STATUS_LABELS, SUBSCRIPTION_STATUS_STYLES } from '@/lib/subscription'
import type { Subscription } from '@/api/types'

const badgeBaseClass = 'inline-flex items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium'

export function SubscriptionStatusBadge({ subscription }: { subscription: Subscription | null }): React.ReactElement {
  if (!subscription) {
    return <span className={cn(badgeBaseClass, 'bg-muted text-muted-foreground border-border')}>Saknar abonnemang</span>
  }

  const label = SUBSCRIPTION_STATUS_LABELS[subscription.display_status]
  const style = SUBSCRIPTION_STATUS_STYLES[subscription.display_status]

  return <span className={cn(badgeBaseClass, style)}>{label}</span>
}
